<div class="page-container" [class.full-bleed]="fullBleed()">
  <ng-content></ng-content>
</div>
